module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-my-list.svg?ee9cbb114263e469254a95c348b27307";